export const FONT_FAMILIES = {
    PRO_LIGHT: "FontAwesomeProLight",
    PRO_REGULAR: "FontAwesomeProRegular",
}

export const fa500px="\uf26e";
export const faAbacus="\uf640";
export const faAccessibleIcon="\uf368";
export const faAccusoft="\uf369";
export const faAcorn="\uf6ae";
export const faAcquisitionsIncorporated="\uf6af";
export const faAd="\uf641";
export const faAddressBook="\uf2b9";
export const faAddressCard="\uf2bb";
export const faAdjust="\uf042";
export const faAdn="\uf170";
export const faAdversal="\uf36a";
export const faAffiliatetheme="\uf36b";
export const faAirConditioner="\uf8f4";
export const faAirFreshener="\uf5d0";
export const faAirbnb="\uf834";
export const faAlarmClock="\uf34e";
export const faAlarmExclamation="\uf843";
export const faAlarmPlus="\uf844";
export const faAlarmSnooze="\uf845";
export const faAlbum="\uf89f";
export const faAlbumCollection="\uf8a0";
export const faAlgolia="\uf36c";
export const faAlicorn="\uf6b0";
export const faAlien="\uf8f5";
export const faAlienMonster="\uf8f6";
export const faAlignCenter="\uf037";
export const faAlignJustify="\uf039";
export const faAlignLeft="\uf036";
export const faAlignRight="\uf038";
export const faAlignSlash="\uf846";
export const faAlipay="\uf642";
export const faAllergies="\uf461";
export const faAmazon="\uf270";
export const faAmazonPay="\uf42c";
export const faAmbulance="\uf0f9";
export const faAmericanSignLanguageInterpreting="\uf2a3";
export const faAmilia="\uf36d";
export const faAmpGuitar="\uf8a1";
export const faAnalytics="\uf643";
export const faAnchor="\uf13d";
export const faAndroid="\uf17b";
export const faAngel="\uf779";
export const faAngellist="\uf209";
export const faAngleDoubleDown="\uf103";
export const faAngleDoubleLeft="\uf100";
export const faAngleDoubleRight="\uf101";
export const faAngleDoubleUp="\uf102";
export const faAngleDown="\uf107";
export const faAngleLeft="\uf104";
export const faAngleRight="\uf105";
export const faAngleUp="\uf106";
export const faAngry="\uf556";
export const faAngrycreative="\uf36e";
export const faAngular="\uf420";
export const faAnkh="\uf644";
export const faAppStore="\uf36f";
export const faAppStoreIos="\uf370";
export const faApper="\uf371";
export const faApple="\uf179";
export const faAppleAlt="\uf5d1";
export const faAppleCrate="\uf6b1";
export const faApplePay="\uf415";
export const faArchive="\uf187";
export const faArchway="\uf557";
export const faArrowAltCircleDown="\uf358";
export const faArrowAltCircleLeft="\uf359";
export const faArrowAltCircleRight="\uf35a";
export const faArrowAltCircleUp="\uf35b";
export const faArrowAltDown="\uf354";
export const faArrowAltFromBottom="\uf346";
export const faArrowAltFromLeft="\uf347";
export const faArrowAltFromRight="\uf348";
export const faArrowAltFromTop="\uf349";
export const faArrowAltLeft="\uf355";
export const faArrowAltRight="\uf356";
export const faArrowAltSquareDown="\uf350";
export const faArrowAltSquareLeft="\uf351";
export const faArrowAltSquareRight="\uf352";
export const faArrowAltSquareUp="\uf353";
export const faArrowAltToBottom="\uf34a";
export const faArrowAltToLeft="\uf34b";
export const faArrowAltToRight="\uf34c";
export const faArrowAltToTop="\uf34d";
export const faArrowAltUp="\uf357";
export const faArrowCircleDown="\uf0ab";
export const faArrowCircleLeft="\uf0a8";
export const faArrowCircleRight="\uf0a9";
export const faArrowCircleUp="\uf0aa";
export const faArrowDown="\uf063";
export const faArrowFromBottom="\uf342";
export const faArrowFromLeft="\uf343";
export const faArrowFromRight="\uf344";
export const faArrowFromTop="\uf345";
export const faArrowLeft="\uf060";
export const faArrowRight="\uf061";
export const faArrowSquareDown="\uf339";
export const faArrowSquareLeft="\uf33a";
export const faArrowSquareRight="\uf33b";
export const faArrowSquareUp="\uf33c";
export const faArrowToBottom="\uf33d";
export const faArrowToLeft="\uf33e";
export const faArrowToRight="\uf340";
export const faArrowToTop="\uf341";
export const faArrowUp="\uf062";
export const faArrows="\uf047";
export const faArrowsAlt="\uf0b2";
export const faArrowsAltH="\uf337";
export const faArrowsAltV="\uf338";
export const faArrowsH="\uf07e";
export const faArrowsV="\uf07d";
export const faArtstation="\uf77a";
export const faAssistiveListeningSystems="\uf2a2";
export const faAsterisk="\uf069";
export const faAsymmetrik="\uf372";
export const faAt="\uf1fa";
export const faAtlas="\uf558";
export const faAtlassian="\uf77b";
export const faAtom="\uf5d2";
export const faAtomAlt="\uf5d3";
export const faAudible="\uf373";
export const faAudioDescription="\uf29e";
export const faAutoprefixer="\uf41c";
export const faAvianex="\uf374";
export const faAviato="\uf421";
export const faAward="\uf559";
export const faAws="\uf375";
export const faAxe="\uf6b2";
export const faAxeBattle="\uf6b3";
export const faBaby="\uf77c";
export const faBabyCarriage="\uf77d";
export const faBackpack="\uf5d4";
export const faBackspace="\uf55a";
export const faBackward="\uf04a";
export const faBacon="\uf7e5";
export const faBacteria="\ue059";
export const faBacterium="\ue05a";
export const faBadge="\uf335";
export const faBadgeCheck="\uf336";
export const faBadgeDollar="\uf645";
export const faBadgePercent="\uf646";
export const faBadgeSheriff="\uf8a2";
export const faBadgerHoney="\uf6b4";
export const faBagsShopping="\uf847";
export const faBahai="\uf666";
export const faBalanceScale="\uf24e";
export const faBalanceScaleLeft="\uf515";
export const faBalanceScaleRight="\uf516";
export const faBallPile="\uf77e";
export const faBallot="\uf732";
export const faBallotCheck="\uf733";
export const faBan="\uf05e";
export const faBandAid="\uf462";
export const faBandcamp="\uf2d5";
export const faBanjo="\uf8a3";
export const faBarcode="\uf02a";
export const faBarcodeAlt="\uf463";
export const faBarcodeRead="\uf464";
export const faBarcodeScan="\uf465";
export const faBars="\uf0c9";
export const faBaseball="\uf432";
export const faBaseballBall="\uf433";
export const faBasketballBall="\uf434";
export const faBasketballHoop="\uf435";
export const faBat="\uf6b5";
export const faBath="\uf2cd";
export const faBatteryBolt="\uf376";
export const faBatteryEmpty="\uf244";
export const faBatteryFull="\uf240";
export const faBatteryHalf="\uf242";
export const faBatteryQuarter="\uf243";
export const faBatterySlash="\uf377";
export const faBatteryThreeQuarters="\uf241";
export const faBattleNet="\uf835";
export const faBed="\uf236";
export const faBedAlt="\uf8f7";
export const faBedBunk="\uf8f8";
export const faBedEmpty="\uf8f9";
export const faBeer="\uf0fc";
export const faBehance="\uf1b4";
export const faBehanceSquare="\uf1b5";
export const faBell="\uf0f3";
export const faBellExclamation="\uf848";
export const faBellOn="\uf8fa";
export const faBellPlus="\uf849";
export const faBellSchool="\uf5d5";
export const faBellSchoolSlash="\uf5d6";
export const faBellSlash="\uf1f6";
export const faBells="\uf77f";
export const faBetamax="\uf8a4";
export const faBezierCurve="\uf55b";
export const faBible="\uf647";
export const faBicycle="\uf206";
export const faBiking="\uf84a";
export const faBikingMountain="\uf84b";
export const faBimobject="\uf378";
export const faBinoculars="\uf1e5";
export const faBiohazard="\uf780";
export const faBirthdayCake="\uf1fd";
export const faBitbucket="\uf171";
export const faBitcoin="\uf379";
export const faBity="\uf37a";
export const faBlackTie="\uf27e";
export const faBlackberry="\uf37b";
export const faBlanket="\uf498";
export const faBlender="\uf517";
export const faBlenderPhone="\uf6b6";
export const faBlind="\uf29d";
export const faBlinds="\uf8fb";
export const faBlindsOpen="\uf8fc";
export const faBlindsRaised="\uf8fd";
export const faBlog="\uf781";
export const faBlogger="\uf37c";
export const faBloggerB="\uf37d";
export const faBluetooth="\uf293";
export const faBluetoothB="\uf294";
export const faBold="\uf032";
export const faBolt="\uf0e7";
export const faBomb="\uf1e2";
export const faBone="\uf5d7";
export const faBoneBreak="\uf5d8";
export const faBong="\uf55c";
export const faBook="\uf02d";
export const faBookAlt="\uf5d9";
export const faBookDead="\uf6b7";
export const faBookHeart="\uf499";
export const faBookMedical="\uf7e6";
export const faBookOpen="\uf518";
export const faBookReader="\uf5da";
export const faBookSpells="\uf6b8";
export const faBookUser="\uf7e7";
export const faBookmark="\uf02e";
export const faBooks="\uf5db";
export const faBooksMedical="\uf7e8";
export const faBoombox="\uf8a5";
export const faBoot="\uf782";
export const faBoothCurtain="\uf734";
export const faBootstrap="\uf836";
export const faBorderAll="\uf84c";
export const faBorderBottom="\uf84d";
export const faBorderCenterH="\uf89c";
export const faBorderCenterV="\uf89d";
export const faBorderInner="\uf84e";
export const faBorderLeft="\uf84f";
export const faBorderNone="\uf850";
export const faBorderOuter="\uf851";
export const faBorderRight="\uf852";
export const faBorderStyle="\uf853";
export const faBorderStyleAlt="\uf854";
export const faBorderTop="\uf855";
export const faBowArrow="\uf6b9";
export const faBowlingBall="\uf436";
export const faBowlingPins="\uf437";
export const faBox="\uf466";
export const faBoxAlt="\uf49a";
export const faBoxBallot="\uf735";
export const faBoxCheck="\uf467";
export const faBoxFragile="\uf49b";
export const faBoxFull="\uf49c";
export const faBoxHeart="\uf49d";
export const faBoxOpen="\uf49e";
export const faBoxTissue="\ue05b";
export const faBoxUp="\uf49f";
export const faBoxUsd="\uf4a0";
export const faBoxes="\uf468";
export const faBoxesAlt="\uf4a1";
export const faBoxingGlove="\uf438";
export const faBrackets="\uf7e9";
export const faBracketsCurly="\uf7ea";
export const faBraille="\uf2a1";
export const faBrain="\uf5dc";
export const faBreadLoaf="\uf7eb";
export const faBreadSlice="\uf7ec";
export const faBriefcase="\uf0b1";
export const faBriefcaseMedical="\uf469";
export const faBringForward="\uf856";
export const faBringFront="\uf857";
export const faBroadcastTower="\uf519";
export const faBroom="\uf51a";
export const faBrowser="\uf37e";
export const faBrush="\uf55d";
export const faBtc="\uf15a";
export const faBuffer="\uf837";
export const faBug="\uf188";
export const faBuilding="\uf1ad";
export const faBullhorn="\uf0a1";
export const faBullseye="\uf140";
export const faBullseyeArrow="\uf648";
export const faBullseyePointer="\uf649";
export const faBurgerSoda="\uf858";
export const faBurn="\uf46a";
export const faBuromobelexperte="\uf37f";
export const faBurrito="\uf7ed";
export const faBus="\uf207";
export const faBusAlt="\uf55e";
export const faBusSchool="\uf5dd";
export const faBusinessTime="\uf64a";
export const faBuyNLarge="\uf8a6";
export const faBuysellads="\uf20d";
export const faCabinetFiling="\uf64b";
export const faCactus="\uf8a7";
export const faCalculator="\uf1ec";
export const faCalculatorAlt="\uf64c";
export const faCalendar="\uf133";
export const faCalendarAlt="\uf073";
export const faCalendarCheck="\uf274";
export const faCalendarDay="\uf783";
export const faCalendarEdit="\uf333";
export const faCalendarExclamation="\uf334";
export const faCalendarMinus="\uf272";
export const faCalendarPlus="\uf271";
export const faCalendarStar="\uf736";
export const faCalendarTimes="\uf273";
export const faCalendarWeek="\uf784";
export const faCamcorder="\uf8a8";
export const faCamera="\uf030";
export const faCameraAlt="\uf332";
export const faCameraHome="\uf8fe";
export const faCameraMovie="\uf8a9";
export const faCameraPolaroid="\uf8aa";
export const faCameraRetro="\uf083";
export const faCampfire="\uf6ba";
export const faCampground="\uf6bb";
export const faCanadianMapleLeaf="\uf785";
export const faCandleHolder="\uf6bc";
export const faCandyCane="\uf786";
export const faCandyCorn="\uf6bd";
export const faCannabis="\uf55f";
export const faCapsules="\uf46b";
export const faCar="\uf1b9";
export const faCarAlt="\uf5de";
export const faCarBattery="\uf5df";
export const faCarBuilding="\uf859";
export const faCarBump="\uf5e0";
export const faCarBus="\uf85a";
export const faCarCrash="\uf5e1";
export const faCarGarage="\uf5e2";
export const faCarMechanic="\uf5e3";
export const faCarSide="\uf5e4";
export const faCarTilt="\uf5e5";
export const faCarWash="\uf5e6";
export const faCaravan="\uf8ff";
export const faCaravanAlt="\ue000";
export const faCaretCircleDown="\uf32d";
export const faCaretCircleLeft="\uf32e";
export const faCaretCircleRight="\uf330";
export const faCaretCircleUp="\uf331";
export const faCaretDown="\uf0d7";
export const faCaretLeft="\uf0d9";
export const faCaretRight="\uf0da";
export const faCaretSquareDown="\uf150";
export const faCaretSquareLeft="\uf191";
export const faCaretSquareRight="\uf152";
export const faCaretSquareUp="\uf151";
export const faCaretUp="\uf0d8";
export const faCarrot="\uf787";
export const faCars="\uf85b";
export const faCartArrowDown="\uf218";
export const faCartPlus="\uf217";
export const faCashRegister="\uf788";
export const faCassetteTape="\uf8ab";
export const faCat="\uf6be";
export const faCatSpace="\ue001";
export const faCauldron="\uf6bf";
export const faCcAmazonPay="\uf42d";
export const faCcAmex="\uf1f3";
export const faCcApplePay="\uf416";
export const faCcDinersClub="\uf24c";
export const faCcDiscover="\uf1f2";
export const faCcJcb="\uf24b";
export const faCcMastercard="\uf1f1";
export const faCcPaypal="\uf1f4";
export const faCcStripe="\uf1f5";
export const faCcVisa="\uf1f0";
export const faCctv="\uf8ac";
export const faCentercode="\uf380";
export const faCentos="\uf789";
export const faCertificate="\uf0a3";
export const faChair="\uf6c0";
export const faChairOffice="\uf6c1";
export const faChalkboard="\uf51b";
export const faChalkboardTeacher="\uf51c";
export const faChargingStation="\uf5e7";
export const faChartArea="\uf1fe";
export const faChartBar="\uf080";
export const faChartLine="\uf201";
export const faChartLineDown="\uf64d";
export const faChartNetwork="\uf78a";
export const faChartPie="\uf200";
export const faChartPieAlt="\uf64e";
export const faChartScatter="\uf7ee";
export const faCheck="\uf00c";
export const faCheckCircle="\uf058";
export const faCheckDouble="\uf560";
export const faCheckSquare="\uf14a";
export const faCheese="\uf7ef";
export const faCheeseSwiss="\uf7f0";
export const faCheeseburger="\uf7f1";
export const faChess="\uf439";
export const faChessBishop="\uf43a";
export const faChessBishopAlt="\uf43b";
export const faChessBoard="\uf43c";
export const faChessClock="\uf43d";
export const faChessClockAlt="\uf43e";
export const faChessKing="\uf43f";
export const faChessKingAlt="\uf440";
export const faChessKnight="\uf441";
export const faChessKnightAlt="\uf442";
export const faChessPawn="\uf443";
export const faChessPawnAlt="\uf444";
export const faChessQueen="\uf445";
export const faChessQueenAlt="\uf446";
export const faChessRook="\uf447";
export const faChessRookAlt="\uf448";
export const faChevronCircleDown="\uf13a";
export const faChevronCircleLeft="\uf137";
export const faChevronCircleRight="\uf138";
export const faChevronCircleUp="\uf139";
export const faChevronDoubleDown="\uf322";
export const faChevronDoubleLeft="\uf323";
export const faChevronDoubleRight="\uf324";
export const faChevronDoubleUp="\uf325";
export const faChevronDown="\uf078";
export const faChevronLeft="\uf053";
export const faChevronRight="\uf054";
export const faChevronSquareDown="\uf329";
export const faChevronSquareLeft="\uf32a";
export const faChevronSquareRight="\uf32b";
export const faChevronSquareUp="\uf32c";
export const faChevronUp="\uf077";
export const faChild="\uf1ae";
export const faChimney="\uf78b";
export const faChrome="\uf268";
export const faChromecast="\uf838";
export const faChurch="\uf51d";
export const faCircle="\uf111";
export const faCircleNotch="\uf1ce";
export const faCity="\uf64f";
export const faClarinet="\uf8ad";
export const faClawMarks="\uf6c2";
export const faClinicMedical="\uf7f2";
export const faClipboard="\uf328";
export const faClipboardCheck="\uf46c";
export const faClipboardList="\uf46d";
export const faClipboardListCheck="\uf737";
export const faClipboardPrescription="\uf5e8";
export const faClipboardUser="\uf7f3";
export const faClock="\uf017";
export const faClone="\uf24d";
export const faClosedCaptioning="\uf20a";
export const faCloud="\uf0c2";
export const faCloudDownload="\uf0ed";
export const faCloudDownloadAlt="\uf381";
export const faCloudDrizzle="\uf738";
export const faCloudHail="\uf739";
export const faCloudHailMixed="\uf73a";
export const faCloudMeatball="\uf73b";
export const faCloudMoon="\uf6c3";
export const faCloudMoonRain="\uf73c";
export const faCloudMusic="\uf8ae";
export const faCloudRain="\uf73d";
export const faCloudRainbow="\uf73e";
export const faCloudShowers="\uf73f";
export const faCloudShowersHeavy="\uf740";
export const faCloudSleet="\uf741";
export const faCloudSnow="\uf742";
export const faCloudSun="\uf6c4";
export const faCloudSunRain="\uf743";
export const faCloudUpload="\uf0ee";
export const faCloudUploadAlt="\uf382";
export const faCloudflare="\ue07d";
export const faClouds="\uf744";
export const faCloudsMoon="\uf745";
export const faCloudsSun="\uf746";
export const faCloudscale="\uf383";
export const faCloudsmith="\uf384";
export const faCloudversify="\uf385";
export const faClub="\uf327";
export const faCocktail="\uf561";
export const faCode="\uf121";
export const faCodeBranch="\uf126";
export const faCodeCommit="\uf386";
export const faCodeMerge="\uf387";
export const faCodepen="\uf1cb";
export const faCodiepie="\uf284";
export const faCoffee="\uf0f4";
export const faCoffeePot="\ue002";
export const faCoffeeTogo="\uf6c5";
export const faCoffin="\uf6c6";
export const faCoffinCross="\ue051";
export const faCog="\uf013";
export const faCogs="\uf085";
export const faCoin="\uf85c";
export const faCoins="\uf51e";
export const faColumns="\uf0db";
export const faComet="\ue003";
export const faComment="\uf075";
export const faCommentAlt="\uf27a";
export const faCommentAltCheck="\uf4a2";
export const faCommentAltDollar="\uf650";
export const faCommentAltDots="\uf4a3";
export const faCommentAltEdit="\uf4a4";
export const faCommentAltExclamation="\uf4a5";
export const faCommentAltLines="\uf4a6";
export const faCommentAltMedical="\uf7f4";
export const faCommentAltMinus="\uf4a7";
export const faCommentAltMusic="\uf8af";
export const faCommentAltPlus="\uf4a8";
export const faCommentAltSlash="\uf4a9";
export const faCommentAltSmile="\uf4aa";
export const faCommentAltTimes="\uf4ab";
export const faCommentCheck="\uf4ac";
export const faCommentDollar="\uf651";
export const faCommentDots="\uf4ad";
export const faCommentEdit="\uf4ae";
export const faCommentExclamation="\uf4af";
export const faCommentLines="\uf4b0";
export const faCommentMedical="\uf7f5";
export const faCommentMinus="\uf4b1";
export const faCommentMusic="\uf8b0";
export const faCommentPlus="\uf4b2";
export const faCommentSlash="\uf4b3";
export const faCommentSmile="\uf4b4";
export const faCommentTimes="\uf4b5";
export const faComments="\uf086";
export const faCommentsAlt="\uf4b6";
export const faCommentsAltDollar="\uf652";
export const faCommentsDollar="\uf653";
export const faCompactDisc="\uf51f";
export const faCompass="\uf14e";
export const faCompassSlash="\uf5e9";
export const faCompress="\uf066";
export const faCompressAlt="\uf422";
export const faCompressArrowsAlt="\uf78c";
export const faCompressWide="\uf326";
export const faComputerClassic="\uf8b1";
export const faComputerSpeaker="\uf8b2";
export const faConciergeBell="\uf562";
export const faConfluence="\uf78d";
export const faConnectdevelop="\uf20e";
export const faConstruction="\uf85d";
export const faContainerStorage="\uf4b7";
export const faContao="\uf26d";
export const faConveyorBelt="\uf46e";
export const faConveyorBeltAlt="\uf46f";
export const faCookie="\uf563";
export const faCookieBite="\uf564";
export const faCopy="\uf0c5";
export const faCopyright="\uf1f9";
export const faCorn="\uf6c7";
export const faCottonBureau="\uf89e";
export const faCouch="\uf4b8";
export const faCow="\uf6c8";
export const faCowbell="\uf8b3";
export const faCowbellMore="\uf8b4";
export const faCpanel="\uf388";
export const faCreativeCommons="\uf25e";
export const faCreativeCommonsBy="\uf4e7";
export const faCreativeCommonsNc="\uf4e8";
export const faCreativeCommonsNcEu="\uf4e9";
export const faCreativeCommonsNcJp="\uf4ea";
export const faCreativeCommonsNd="\uf4eb";
export const faCreativeCommonsPd="\uf4ec";
export const faCreativeCommonsPdAlt="\uf4ed";
export const faCreativeCommonsRemix="\uf4ee";
export const faCreativeCommonsSa="\uf4ef";
export const faCreativeCommonsSampling="\uf4f0";
export const faCreativeCommonsSamplingPlus="\uf4f1";
export const faCreativeCommonsShare="\uf4f2";
export const faCreativeCommonsZero="\uf4f3";
export const faCreditCard="\uf09d";
export const faCreditCardBlank="\uf389";
export const faCreditCardFront="\uf38a";
export const faCricket="\uf449";
export const faCriticalRole="\uf6c9";
export const faCroissant="\uf7f6";
export const faCrop="\uf125";
export const faCropAlt="\uf565";
export const faCross="\uf654";
export const faCrosshairs="\uf05b";
export const faCrow="\uf520";
export const faCrown="\uf521";
export const faCrutch="\uf7f7";
export const faCrutches="\uf7f8";
export const faCss3="\uf13c";
export const faCss3Alt="\uf38b";
export const faCube="\uf1b2";
export const faCubes="\uf1b3";
export const faCurling="\uf44a";
export const faCut="\uf0c4";
export const faCuttlefish="\uf38c";
export const faDAndD="\uf38d";
export const faDAndDBeyond="\uf6ca";
export const faDagger="\uf6cb";
export const faDailymotion="\ue052";
export const faDashcube="\uf210";
export const faDatabase="\uf1c0";
export const faDeaf="\uf2a4";
export const faDebug="\uf7f9";
export const faDeer="\uf78e";
export const faDeerRudolph="\uf78f";
export const faDeezer="\ue077";
export const faDelicious="\uf1a5";
export const faDemocrat="\uf747";
export const faDeploydog="\uf38e";
export const faDeskpro="\uf38f";
export const faDesktop="\uf108";
export const faDesktopAlt="\uf390";
export const faDev="\uf6cc";
export const faDeviantart="\uf1bd";
export const faDewpoint="\uf748";
export const faDharmachakra="\uf655";
export const faDhl="\uf790";
export const faDiagnoses="\uf470";
export const faDiamond="\uf219";
export const faDiaspora="\uf791";
export const faDice="\uf522";
export const faDiceD10="\uf6cd";
export const faDiceD12="\uf6ce";
export const faDiceD20="\uf6cf";
export const faDiceD4="\uf6d0";
export const faDiceD6="\uf6d1";
export const faDiceD8="\uf6d2";
export const faDiceFive="\uf523";
export const faDiceFour="\uf524";
export const faDiceOne="\uf525";
export const faDiceSix="\uf526";
export const faDiceThree="\uf527";
export const faDiceTwo="\uf528";
export const faDigg="\uf1a6";
export const faDigging="\uf85e";
export const faDigitalOcean="\uf391";
export const faDigitalTachograph="\uf566";
export const faDiploma="\uf5ea";
export const faDirections="\uf5eb";
export const faDiscDrive="\uf8b5";
export const faDiscord="\uf392";
export const faDiscourse="\uf393";
export const faDisease="\uf7fa";
export const faDivide="\uf529";
export const faDizzy="\uf567";
export const faDna="\uf471";
export const faDoNotEnter="\uf5ec";
export const faDochub="\uf394";
export const faDocker="\uf395";
export const faDog="\uf6d3";
export const faDogLeashed="\uf6d4";
export const faDollarSign="\uf155";
export const faDolly="\uf472";
export const faDollyEmpty="\uf473";
export const faDollyFlatbed="\uf474";
export const faDollyFlatbedAlt="\uf475";
export const faDollyFlatbedEmpty="\uf476";
export const faDonate="\uf4b9";
export const faDoorClosed="\uf52a";
export const faDoorOpen="\uf52b";
export const faDotCircle="\uf192";
export const faDove="\uf4ba";
export const faDownload="\uf019";
export const faDraft2digital="\uf396";
export const faDraftingCompass="\uf568";
export const faDragon="\uf6d5";
export const faDrawCircle="\uf5ed";
export const faDrawPolygon="\uf5ee";
export const faDrawSquare="\uf5ef";
export const faDreidel="\uf792";
export const faDribbble="\uf17d";
export const faDribbbleSquare="\uf397";
export const faDrone="\uf85f";
export const faDroneAlt="\uf860";
export const faDropbox="\uf16b";
export const faDrum="\uf569";
export const faDrumSteelpan="\uf56a";
export const faDrumstick="\uf6d6";
export const faDrumstickBite="\uf6d7";
export const faDrupal="\uf1a9";
export const faDryer="\uf861";
export const faDryerAlt="\uf862";
export const faDuck="\uf6d8";
export const faDumbbell="\uf44b";
export const faDumpster="\uf793";
export const faDumpsterFire="\uf794";
export const faDungeon="\uf6d9";
export const faDyalog="\uf399";
export const faEar="\uf5f0";
export const faEarMuffs="\uf795";
export const faEarlybirds="\uf39a";
export const faEbay="\uf4f4";
export const faEclipse="\uf749";
export const faEclipseAlt="\uf74a";
export const faEdge="\uf282";
export const faEdgeLegacy="\ue078";
export const faEdit="\uf044";
export const faEgg="\uf7fb";
export const faEggFried="\uf7fc";
export const faEject="\uf052";
export const faElementor="\uf430";
export const faElephant="\uf6da";
export const faEllipsisH="\uf141";
export const faEllipsisHAlt="\uf39b";
export const faEllipsisV="\uf142";
export const faEllipsisVAlt="\uf39c";
export const faEllo="\uf5f1";
export const faEmber="\uf423";
export const faEmpire="\uf1d1";
export const faEmptySet="\uf656";
export const faEngineWarning="\uf5f2";
export const faEnvelope="\uf0e0";
export const faEnvelopeOpen="\uf2b6";
export const faEnvelopeOpenDollar="\uf657";
export const faEnvelopeOpenText="\uf658";
export const faEnvelopeSquare="\uf199";
export const faEnvira="\uf299";
export const faEquals="\uf52c";
export const faEraser="\uf12d";
export const faErlang="\uf39d";
export const faEthereum="\uf42e";
export const faEthernet="\uf796";
export const faEtsy="\uf2d7";
export const faEuroSign="\uf153";
export const faEvernote="\uf839";
export const faExchange="\uf0ec";
export const faExchangeAlt="\uf362";
export const faExclamation="\uf12a";
export const faExclamationCircle="\uf06a";
export const faExclamationSquare="\uf321";
export const faExclamationTriangle="\uf071";
export const faExpand="\uf065";
export const faExpandAlt="\uf424";
export const faExpandArrows="\uf31d";
export const faExpandArrowsAlt="\uf31e";
export const faExpandWide="\uf320";
export const faExpeditedssl="\uf23e";
export const faExternalLink="\uf08e";
export const faExternalLinkAlt="\uf35d";
export const faExternalLinkSquare="\uf14c";
export const faExternalLinkSquareAlt="\uf360";
export const faEye="\uf06e";
export const faEyeDropper="\uf1fb";
export const faEyeEvil="\uf6db";
export const faEyeSlash="\uf070";
export const faFacebook="\uf09a";
export const faFacebookF="\uf39e";
export const faFacebookMessenger="\uf39f";
export const faFacebookSquare="\uf082";
export const faFan="\uf863";
export const faFanTable="\ue004";
export const faFantasyFlightGames="\uf6dc";
export const faFarm="\uf864";
export const faFastBackward="\uf049";
export const faFastForward="\uf050";
export const faFaucet="\ue005";
export const faFaucetDrip="\ue006";
export const faFax="\uf1ac";
export const faFeather="\uf52d";
export const faFeatherAlt="\uf56b";
export const faFedex="\uf797";
export const faFedora="\uf798";
export const faFemale="\uf182";
export const faFieldHockey="\uf44c";
export const faFighterJet="\uf0fb";
export const faFigma="\uf799";
export const faFile="\uf15b";
export const faFileAlt="\uf15c";
export const faFileArchive="\uf1c6";
export const faFileAudio="\uf1c7";
export const faFileCertificate="\uf5f3";
export const faFileChartLine="\uf659";
export const faFileChartPie="\uf65a";
export const faFileCheck="\uf316";
export const faFileCode="\uf1c9";
export const faFileContract="\uf56c";
export const faFileCsv="\uf6dd";
export const faFileDownload="\uf56d";
export const faFileEdit="\uf31c";
export const faFileExcel="\uf1c3";
export const faFileExclamation="\uf31a";
export const faFileExport="\uf56e";
export const faFileImage="\uf1c5";
export const faFileImport="\uf56f";
export const faFileInvoice="\uf570";
export const faFileInvoiceDollar="\uf571";
export const faFileMedical="\uf477";
export const faFileMedicalAlt="\uf478";
export const faFileMinus="\uf318";
export const faFileMusic="\uf8b6";
export const faFilePdf="\uf1c1";
export const faFilePlus="\uf319";
export const faFilePowerpoint="\uf1c4";
export const faFilePrescription="\uf572";
export const faFileSearch="\uf865";
export const faFileSignature="\uf573";
export const faFileSpreadsheet="\uf65b";
export const faFileTimes="\uf317";
export const faFileUpload="\uf574";
export const faFileUser="\uf65c";
export const faFileVideo="\uf1c8";
export const faFileWord="\uf1c2";
export const faFilesMedical="\uf7fd";
export const faFill="\uf575";
export const faFillDrip="\uf576";
export const faFilm="\uf008";
export const faFilmAlt="\uf3a0";
export const faFilmCanister="\uf8b7";
export const faFilter="\uf0b0";
export const faFingerprint="\uf577";
export const faFire="\uf06d";
export const faFireAlt="\uf7e4";
export const faFireExtinguisher="\uf134";
export const faFireSmoke="\uf74b";
export const faFirefox="\uf269";
export const faFirefoxBrowser="\ue007";
export const faFireplace="\uf79a";
export const faFirstAid="\uf479";
export const faFirstOrder="\uf2b0";
export const faFirstOrderAlt="\uf50a";
export const faFirstdraft="\uf3a1";
export const faFish="\uf578";
export const faFishCooked="\uf7fe";
export const faFistRaised="\uf6de";
export const faFlag="\uf024";
export const faFlagAlt="\uf74c";
export const faFlagCheckered="\uf11e";
export const faFlagUsa="\uf74d";
export const faFlame="\uf6df";
export const faFlashlight="\uf8b8";
export const faFlask="\uf0c3";
export const faFlaskPoison="\uf6e0";
export const faFlaskPotion="\uf6e1";
export const faFlickr="\uf16e";
export const faFlipboard="\uf44d";
export const faFlower="\uf7ff";
export const faFlowerDaffodil="\uf800";
export const faFlowerTulip="\uf801";
export const faFlushed="\uf579";
export const faFlute="\uf8b9";
export const faFluxCapacitor="\uf8ba";
export const faFly="\uf417";
export const faFog="\uf74e";
export const faFolder="\uf07b";
export const faFolderDownload="\ue053";
export const faFolderMinus="\uf65d";
export const faFolderOpen="\uf07c";
export const faFolderPlus="\uf65e";
export const faFolderTimes="\uf65f";
export const faFolderTree="\uf802";
export const faFolderUpload="\ue054";
export const faFolders="\uf660";
export const faFont="\uf031";
export const faFontAwesome="\uf2b4";
export const faFontAwesomeAlt="\uf35c";
export const faFontAwesomeFlag="\uf425";
export const faFontAwesomeLogoFull="\uf4e6";
export const faFontCase="\uf866";
export const faFonticons="\uf280";
export const faFonticonsFi="\uf3a2";
export const faFootballBall="\uf44e";
export const faFootballHelmet="\uf44f";
export const faForklift="\uf47a";
export const faFortAwesome="\uf286";
export const faFortAwesomeAlt="\uf3a3";
export const faForumbee="\uf211";
export const faForward="\uf04e";
export const faFoursquare="\uf180";
export const faFragile="\uf4bb";
export const faFreeCodeCamp="\uf2c5";
export const faFreebsd="\uf3a4";
export const faFrenchFries="\uf803";
export const faFrog="\uf52e";
export const faFrostyHead="\uf79b";
export const faFrown="\uf119";
export const faFrownOpen="\uf57a";
export const faFulcrum="\uf50b";
export const faFunction="\uf661";
export const faFunnelDollar="\uf662";
export const faFutbol="\uf1e3";
export const faGalacticRepublic="\uf50c";
export const faGalacticSenate="\uf50d";
export const faGalaxy="\ue008";
export const faGameBoard="\uf867";
export const faGameBoardAlt="\uf868";
export const faGameConsoleHandheld="\uf8bb";
export const faGamepad="\uf11b";
export const faGamepadAlt="\uf8bc";
export const faGarage="\ue009";
export const faGarageCar="\ue00a";
export const faGarageOpen="\ue00b";
export const faGasPump="\uf52f";
export const faGasPumpSlash="\uf5f4";
export const faGavel="\uf0e3";
export const faGem="\uf3a5";
export const faGenderless="\uf22d";
export const faGetPocket="\uf265";
export const faGg="\uf260";
export const faGgCircle="\uf261";
export const faGhost="\uf6e2";
export const faGift="\uf06b";
export const faGiftCard="\uf663";
export const faGifts="\uf79c";
export const faGingerbreadMan="\uf79d";
export const faGit="\uf1d3";
export const faGitAlt="\uf841";
export const faGitSquare="\uf1d2";
export const faGithub="\uf09b";
export const faGithubAlt="\uf113";
export const faGithubSquare="\uf092";
export const faGitkraken="\uf3a6";
export const faGitlab="\uf296";
export const faGitter="\uf426";
export const faGlass="\uf804";
export const faGlassChampagne="\uf79e";
export const faGlassCheers="\uf79f";
export const faGlassCitrus="\uf869";
export const faGlassMartini="\uf000";
export const faGlassMartiniAlt="\uf57b";
export const faGlassWhiskey="\uf7a0";
export const faGlassWhiskeyRocks="\uf7a1";
export const faGlasses="\uf530";
export const faGlassesAlt="\uf5f5";
export const faGlide="\uf2a5";
export const faGlideG="\uf2a6";
export const faGlobe="\uf0ac";
export const faGlobeAfrica="\uf57c";
export const faGlobeAmericas="\uf57d";
export const faGlobeAsia="\uf57e";
export const faGlobeEurope="\uf7a2";
export const faGlobeSnow="\uf7a3";
export const faGlobeStand="\uf5f6";
export const faGofore="\uf3a7";
export const faGolfBall="\uf450";
export const faGolfClub="\uf451";
export const faGoodreads="\uf3a8";
export const faGoodreadsG="\uf3a9";
export const faGoogle="\uf1a0";
export const faGoogleDrive="\uf3aa";
export const faGooglePay="\ue079";
export const faGooglePlay="\uf3ab";
export const faGooglePlus="\uf2b3";
export const faGooglePlusG="\uf0d5";
export const faGooglePlusSquare="\uf0d4";
export const faGoogleWallet="\uf1ee";
export const faGopuram="\uf664";
export const faGraduationCap="\uf19d";
export const faGramophone="\uf8bd";
export const faGratipay="\uf184";
export const faGrav="\uf2d6";
export const faGreaterThan="\uf531";
export const faGreaterThanEqual="\uf532";
export const faGrimace="\uf57f";
export const faGrin="\uf580";
export const faGrinAlt="\uf581";
export const faGrinBeam="\uf582";
export const faGrinBeamSweat="\uf583";
export const faGrinHearts="\uf584";
export const faGrinSquint="\uf585";
export const faGrinSquintTears="\uf586";
export const faGrinStars="\uf587";
export const faGrinTears="\uf588";
export const faGrinTongue="\uf589";
export const faGrinTongueSquint="\uf58a";
export const faGrinTongueWink="\uf58b";
export const faGrinWink="\uf58c";
export const faGripHorizontal="\uf58d";
export const faGripLines="\uf7a4";
export const faGripLinesVertical="\uf7a5";
export const faGripVertical="\uf58e";
export const faGripfire="\uf3ac";
export const faGrunt="\uf3ad";
export const faGuilded="\ue07e";
export const faGuitar="\uf7a6";
export const faGuitarElectric="\uf8be";
export const faGuitars="\uf8bf";
export const faGulp="\uf3ae";
export const faHSquare="\uf0fd";
export const faH1="\uf313";
export const faH2="\uf314";
export const faH3="\uf315";
export const faH4="\uf86a";
export const faHackerNews="\uf1d4";
export const faHackerNewsSquare="\uf3af";
export const faHackerrank="\uf5f7";
export const faHamburger="\uf805";
export const faHammer="\uf6e3";
export const faHammerWar="\uf6e4";
export const faHamsa="\uf665";
export const faHandHeart="\uf4bc";
export const faHandHolding="\uf4bd";
export const faHandHoldingBox="\uf47b";
export const faHandHoldingHeart="\uf4be";
export const faHandHoldingMagic="\uf6e5";
export const faHandHoldingMedical="\ue05c";
export const faHandHoldingSeedling="\uf4bf";
export const faHandHoldingUsd="\uf4c0";
export const faHandHoldingWater="\uf4c1";
export const faHandLizard="\uf258";
export const faHandMiddleFinger="\uf806";
export const faHandPaper="\uf256";
export const faHandPeace="\uf25b";
export const faHandPointDown="\uf0a7";
export const faHandPointLeft="\uf0a5";
export const faHandPointRight="\uf0a4";
export const faHandPointUp="\uf0a6";
export const faHandPointer="\uf25a";
export const faHandReceiving="\uf47c";
export const faHandRock="\uf255";
export const faHandScissors="\uf257";
export const faHandSparkles="\ue05d";
export const faHandSpock="\uf259";
export const faHands="\uf4c2";
export const faHandsHeart="\uf4c3";
export const faHandsHelping="\uf4c4";
export const faHandsUsd="\uf4c5";
export const faHandsWash="\ue05e";
export const faHandshake="\uf2b5";
export const faHandshakeAlt="\uf4c6";
export const faHandshakeAltSlash="\ue05f";
export const faHandshakeSlash="\ue060";
export const faHanukiah="\uf6e6";
export const faHardHat="\uf807";
export const faHashtag="\uf292";
export const faHatChef="\uf86b";
export const faHatCowboy="\uf8c0";
export const faHatCowboySide="\uf8c1";
export const faHatSanta="\uf7a7";
export const faHatWinter="\uf7a8";
export const faHatWitch="\uf6e7";
export const faHatWizard="\uf6e8";
export const faHdd="\uf0a0";
export const faHeadSide="\uf6e9";
export const faHeadSideBrain="\uf808";
export const faHeadSideCough="\ue061";
export const faHeadSideCoughSlash="\ue062";
export const faHeadSideHeadphones="\uf8c2";
export const faHeadSideMask="\ue063";
export const faHeadSideMedical="\uf809";
export const faHeadSideVirus="\ue064";
export const faHeadVr="\uf6ea";
export const faHeading="\uf1dc";
export const faHeadphones="\uf025";
export const faHeadphonesAlt="\uf58f";
export const faHeadset="\uf590";
export const faHeart="\uf004";
export const faHeartBroken="\uf7a9";
export const faHeartCircle="\uf4c7";
export const faHeartRate="\uf5f8";
export const faHeartSquare="\uf4c8";
export const faHeartbeat="\uf21e";
export const faHeat="\ue00c";
export const faHelicopter="\uf533";
export const faHelmetBattle="\uf6eb";
export const faHexagon="\uf312";
export const faHighlighter="\uf591";
export const faHiking="\uf6ec";
export const faHippo="\uf6ed";
export const faHips="\uf452";
export const faHireAHelper="\uf3b0";
export const faHistory="\uf1da";
export const faHive="\ue07f";
export const faHockeyMask="\uf6ee";
export const faHockeyPuck="\uf453";
export const faHockeySticks="\uf454";
export const faHollyBerry="\uf7aa";
export const faHome="\uf015";
export const faHomeAlt="\uf80a";
export const faHomeHeart="\uf4c9";
export const faHomeLg="\uf80b";
export const faHomeLgAlt="\uf80c";
export const faHoodCloak="\uf6ef";
export const faHooli="\uf427";
export const faHorizontalRule="\uf86c";
export const faHornbill="\uf592";
export const faHorse="\uf6f0";
export const faHorseHead="\uf7ab";
export const faHorseSaddle="\uf8c3";
export const faHospital="\uf0f8";
export const faHospitalAlt="\uf47d";
export const faHospitalSymbol="\uf47e";
export const faHospitalUser="\uf80d";
export const faHospitals="\uf80e";
export const faHotTub="\uf593";
export const faHotdog="\uf80f";
export const faHotel="\uf594";
export const faHotjar="\uf3b1";
export const faHourglass="\uf254";
export const faHourglassEnd="\uf253";
export const faHourglassHalf="\uf252";
export const faHourglassStart="\uf251";
export const faHouse="\ue00d";
export const faHouseDamage="\uf6f1";
export const faHouseDay="\ue00e";
export const faHouseFlood="\uf74f";
export const faHouseLeave="\ue00f";
export const faHouseNight="\ue010";
export const faHouseReturn="\ue011";
export const faHouseSignal="\ue012";
export const faHouseUser="\ue065";
export const faHouzz="\uf27c";
export const faHryvnia="\uf6f2";
export const faHtml5="\uf13b";
export const faHubspot="\uf3b2";
export const faHumidity="\uf750";
export const faHurricane="\uf751";
export const faICursor="\uf246";
export const faIceCream="\uf810";
export const faIceSkate="\uf7ac";
export const faIcicles="\uf7ad";
export const faIcons="\uf86d";
export const faIconsAlt="\uf86e";
export const faIdBadge="\uf2c1";
export const faIdCard="\uf2c2";
export const faIdCardAlt="\uf47f";
export const faIdeal="\ue013";
export const faIgloo="\uf7ae";
export const faImage="\uf03e";
export const faImagePolaroid="\uf8c4";
export const faImages="\uf302";
export const faImdb="\uf2d8";
export const faInbox="\uf01c";
export const faInboxIn="\uf310";
export const faInboxOut="\uf311";
export const faIndent="\uf03c";
export const faIndustry="\uf275";
export const faIndustryAlt="\uf3b3";
export const faInfinity="\uf534";
export const faInfo="\uf129";
export const faInfoCircle="\uf05a";
export const faInfoSquare="\uf30f";
export const faInhaler="\uf5f9";
export const faInnosoft="\ue080";
export const faInstagram="\uf16d";
export const faInstagramSquare="\ue055";
export const faInstalod="\ue081";
export const faIntegral="\uf667";
export const faIntercom="\uf7af";
export const faInternetExplorer="\uf26b";
export const faIntersection="\uf668";
export const faInventory="\uf480";
export const faInvision="\uf7b0";
export const faIoxhost="\uf208";
export const faIslandTropical="\uf811";
export const faItalic="\uf033";
export const faItchIo="\uf83a";
export const faItunes="\uf3b4";
export const faItunesNote="\uf3b5";
export const faJackOLantern="\uf30e";
export const faJava="\uf4e4";
export const faJedi="\uf669";
export const faJediOrder="\uf50e";
export const faJenkins="\uf3b6";
export const faJira="\uf7b1";
export const faJoget="\uf3b7";
export const faJoint="\uf595";
export const faJoomla="\uf1aa";
export const faJournalWhills="\uf66a";
export const faJoystick="\uf8c5";
export const faJs="\uf3b8";
export const faJsSquare="\uf3b9";
export const faJsfiddle="\uf1cc";
export const faJug="\uf8c6";
export const faKaaba="\uf66b";
export const faKaggle="\uf5fa";
export const faKazoo="\uf8c7";
export const faKerning="\uf86f";
export const faKey="\uf084";
export const faKeySkeleton="\uf6f3";
export const faKeybase="\uf4f5";
export const faKeyboard="\uf11c";
export const faKeycdn="\uf3ba";
export const faKeynote="\uf66c";
export const faKhanda="\uf66d";
export const faKickstarter="\uf3bb";
export const faKickstarterK="\uf3bc";
export const faKidneys="\uf5fb";
export const faKiss="\uf596";
export const faKissBeam="\uf597";
export const faKissWinkHeart="\uf598";
export const faKite="\uf6f4";
export const faKiwiBird="\uf535";
export const faKnifeKitchen="\uf6f5";
export const faKorvue="\uf42f";
export const faLambda="\uf66e";
export const faLamp="\uf4ca";
export const faLampDesk="\ue014";
export const faLampFloor="\ue015";
export const faLandmark="\uf66f";
export const faLandmarkAlt="\uf752";
export const faLanguage="\uf1ab";
export const faLaptop="\uf109";
export const faLaptopCode="\uf5fc";
export const faLaptopHouse="\ue066";
export const faLaptopMedical="\uf812";
export const faLaravel="\uf3bd";
export const faLasso="\uf8c8";
export const faLastfm="\uf202";
export const faLastfmSquare="\uf203";
export const faLaugh="\uf599";
export const faLaughBeam="\uf59a";
export const faLaughSquint="\uf59b";
export const faLaughWink="\uf59c";
export const faLaundry ="\uf862";
export const faLayerGroup="\uf5fd";
export const faLayerMinus="\uf5fe";
export const faLayerPlus="\uf5ff";
export const faLeaf="\uf06c";
export const faLeafHeart="\uf4cb";
export const faLeafMaple="\uf6f6";
export const faLeafOak="\uf6f7";
export const faLeanpub="\uf212";
export const faLemon="\uf094";
export const faLess="\uf41d";
export const faLessThan="\uf536";
export const faLessThanEqual="\uf537";
export const faLevelDown="\uf149";
export const faLevelDownAlt="\uf3be";
export const faLevelUp="\uf148";
export const faLevelUpAlt="\uf3bf";
export const faLifeRing="\uf1cd";
export const faLightCeiling="\ue016";
export const faLightSwitch="\ue017";
export const faLightSwitchOff="\ue018";
export const faLightSwitchOn="\ue019";
export const faLightbulb="\uf0eb";
export const faLightbulbDollar="\uf670";
export const faLightbulbExclamation="\uf671";
export const faLightbulbOn="\uf672";
export const faLightbulbSlash="\uf673";
export const faLightsHoliday="\uf7b2";
export const faLine="\uf3c0";
export const faLineColumns="\uf870";
export const faLineHeight="\uf871";
export const faLink="\uf0c1";
export const faLinkedin="\uf08c";
export const faLinkedinIn="\uf0e1";
export const faLinode="\uf2b8";
export const faLinux="\uf17c";
export const faLips="\uf600";
export const faLiraSign="\uf195";
export const faList="\uf03a";
export const faListAlt="\uf022";
export const faListMusic="\uf8c9";
export const faListOl="\uf0cb";
export const faListUl="\uf0ca";
export const faLocation="\uf601";
export const faLocationArrow="\uf124";
export const faLocationCircle="\uf602";
export const faLocationSlash="\uf603";
export const faLock="\uf023";
export const faLockAlt="\uf30d";
export const faLockOpen="\uf3c1";
export const faLockOpenAlt="\uf3c2";
export const faLongArrowAltDown="\uf309";
export const faLongArrowAltLeft="\uf30a";
export const faLongArrowAltRight="\uf30b";
export const faLongArrowAltUp="\uf30c";
export const faLongArrowDown="\uf175";
export const faLongArrowLeft="\uf177";
export const faLongArrowRight="\uf178";
export const faLongArrowUp="\uf176";
export const faLoveseat="\uf4cc";
export const faLowVision="\uf2a8";
export const faLuchador="\uf455";
export const faLuggageCart="\uf59d";
export const faLungs="\uf604";
export const faLungsVirus="\ue067";
export const faLyft="\uf3c3";
export const faMace="\uf6f8";
export const faMagento="\uf3c4";
export const faMagic="\uf0d0";
export const faMagnet="\uf076";
export const faMailBulk="\uf674";
export const faMailbox="\uf813";
export const faMailchimp="\uf59e";
export const faMale="\uf183";
export const faMandalorian="\uf50f";
export const faMandolin="\uf6f9";
export const faMap="\uf279";
export const faMapMarked="\uf59f";
export const faMapMarkedAlt="\uf5a0";
export const faMapMarker="\uf041";
export const faMapMarkerAlt="\uf3c5";
export const faMapMarkerAltSlash="\uf605";
export const faMapMarkerCheck="\uf606";
export const faMapMarkerEdit="\uf607";
export const faMapMarkerExclamation="\uf608";
export const faMapMarkerMinus="\uf609";
export const faMapMarkerPlus="\uf60a";
export const faMapMarkerQuestion="\uf60b";
export const faMapMarkerSlash="\uf60c";
export const faMapMarkerSmile="\uf60d";
export const faMapMarkerTimes="\uf60e";
export const faMapPin="\uf276";
export const faMapSigns="\uf277";
export const faMarkdown="\uf60f";
export const faMarker="\uf5a1";
export const faMars="\uf222";
export const faMarsDouble="\uf227";
export const faMarsStroke="\uf229";
export const faMarsStrokeH="\uf22b";
export const faMarsStrokeV="\uf22a";
export const faMask="\uf6fa";
export const faMastodon="\uf4f6";
export const faMaxcdn="\uf136";
export const faMdb="\uf8ca";
export const faMeat="\uf814";
export const faMedal="\uf5a2";
export const faMedapps="\uf3c6";
export const faMedium="\uf23a";
export const faMediumM="\uf3c7";
export const faMedkit="\uf0fa";
export const faMedrt="\uf3c8";
export const faMeetup="\uf2e0";
export const faMegaphone="\uf675";
export const faMegaport="\uf5a3";
export const faMeh="\uf11a";
export const faMehBlank="\uf5a4";
export const faMehRollingEyes="\uf5a5";
export const faMemory="\uf538";
export const faMendeley="\uf7b3";
export const faMenorah="\uf676";
export const faMercury="\uf223";
export const faMeteor="\uf753";
export const faMicroblog="\ue01a";
export const faMicrochip="\uf2db";
export const faMicrophone="\uf130";
export const faMicrophoneAlt="\uf3c9";
export const faMicrophoneAltSlash="\uf539";
export const faMicrophoneSlash="\uf131";
export const faMicrophoneStand="\uf8cb";
export const faMicroscope="\uf610";
export const faMicrosoft="\uf3ca";
export const faMicrowave="\ue01b";
export const faMindShare="\uf677";
export const faMinus="\uf068";
export const faMinusCircle="\uf056";
export const faMinusHexagon="\uf307";
export const faMinusOctagon="\uf308";
export const faMinusSquare="\uf146";
export const faMistletoe="\uf7b4";
export const faMitten="\uf7b5";
export const faMix="\uf3cb";
export const faMixcloud="\uf289";
export const faMixer="\ue056";
export const faMizuni="\uf3cc";
export const faMobile="\uf10b";
export const faMobileAlt="\uf3cd";
export const faMobileAndroid="\uf3ce";
export const faMobileAndroidAlt="\uf3cf";
export const faModx="\uf285";
export const faMonero="\uf3d0";
export const faMoneyBill="\uf0d6";
export const faMoneyBillAlt="\uf3d1";
export const faMoneyBillWave="\uf53a";
export const faMoneyBillWaveAlt="\uf53b";
export const faMoneyCheck="\uf53c";
export const faMoneyCheckAlt="\uf53d";
export const faMoneyCheckEdit="\uf872";
export const faMoneyCheckEditAlt="\uf873";
export const faMonitorHeartRate="\uf611";
export const faMonkey="\uf6fb";
export const faMonument="\uf5a6";
export const faMoon="\uf186";
export const faMoonCloud="\uf754";
export const faMoonStars="\uf755";
export const faMortarPestle="\uf5a7";
export const faMosque="\uf678";
export const faMotorcycle="\uf21c";
export const faMountain="\uf6fc";
export const faMountains="\uf6fd";
export const faMouse="\uf8cc";
export const faMouseAlt="\uf8cd";
export const faMousePointer="\uf245";
export const faMp3Player="\uf8ce";
export const faMug="\uf874";
export const faMugHot="\uf7b6";
export const faMugMarshmallows="\uf7b7";
export const faMugTea="\uf875";
export const faMusic="\uf001";
export const faMusicAlt="\uf8cf";
export const faMusicAltSlash="\uf8d0";
export const faMusicSlash="\uf8d1";
export const faNapster="\uf3d2";
export const faNarwhal="\uf6fe";
export const faNeos="\uf612";
export const faNetworkWired="\uf6ff";
export const faNeuter="\uf22c";
export const faNewspaper="\uf1ea";
export const faNimblr="\uf5a8";
export const faNode="\uf419";
export const faNodeJs="\uf3d3";
export const faNotEqual="\uf53e";
export const faNotesMedical="\uf481";
export const faNpm="\uf3d4";
export const faNs8="\uf3d5";
export const faNutritionix="\uf3d6";
export const faObjectGroup="\uf247";
export const faObjectUngroup="\uf248";
export const faOctagon="\uf306";
export const faOctopusDeploy="\ue082";
export const faOdnoklassniki="\uf263";
export const faOdnoklassnikiSquare="\uf264";
export const faOilCan="\uf613";
export const faOilTemp="\uf614";
export const faOldRepublic="\uf510";
export const faOm="\uf679";
export const faOmega="\uf67a";
export const faOpencart="\uf23d";
export const faOpenid="\uf19b";
export const faOpera="\uf26a";
export const faOptinMonster="\uf23c";
export const faOrcid="\uf8d2";
export const faOrnament="\uf7b8";
export const faOsi="\uf41a";
export const faOtter="\uf700";
export const faOutdent="\uf03b";
export const faOutlet="\ue01c";
export const faOven="\ue01d";
export const faOverline="\uf876";
export const faPageBreak="\uf877";
export const faPage4="\uf3d7";
export const faPagelines="\uf18c";
export const faPager="\uf815";
export const faPaintBrush="\uf1fc";
export const faPaintBrushAlt="\uf5a9";
export const faPaintRoller="\uf5aa";
export const faPalette="\uf53f";
export const faPalfed="\uf3d8";
export const faPallet="\uf482";
export const faPalletAlt="\uf483";
export const faPaperPlane="\uf1d8";
export const faPaperclip="\uf0c6";
export const faParachuteBox="\uf4cd";
export const faParagraph="\uf1dd";
export const faParagraphRtl="\uf878";
export const faParking="\uf540";
export const faParkingCircle="\uf615";
export const faParkingCircleSlash="\uf616";
export const faParkingSlash="\uf617";
export const faPassport="\uf5ab";
export const faPastafarianism="\uf67b";
export const faPaste="\uf0ea";
export const faPatreon="\uf3d9";
export const faPause="\uf04c";
export const faPauseCircle="\uf28b";
export const faPaw="\uf1b0";
export const faPawAlt="\uf701";
export const faPawClaws="\uf702";
export const faPaypal="\uf1ed";
export const faPeace="\uf67c";
export const faPegasus="\uf703";
export const faPen="\uf304";
export const faPenAlt="\uf305";
export const faPenFancy="\uf5ac";
export const faPenNib="\uf5ad";
export const faPenSquare="\uf14b";
export const faPencil="\uf040";
export const faPencilAlt="\uf303";
export const faPencilPaintbrush="\uf618";
export const faPencilRuler="\uf5ae";
export const faPennant="\uf456";
export const faPennyArcade="\uf704";
export const faPeopleArrows="\ue068";
export const faPeopleCarry="\uf4ce";
export const faPepperHot="\uf816";
export const faPerbyte="\ue083";
export const faPercent="\uf295";
export const faPercentage="\uf541";
export const faPeriscope="\uf3da";
export const faPersonBooth="\uf756";
export const faPersonCarry="\uf4cf";
export const faPersonDolly="\uf4d0";
export const faPersonDollyEmpty="\uf4d1";
export const faPersonSign="\uf757";
export const faPhabricator="\uf3db";
export const faPhoenixFramework="\uf3dc";
export const faPhoenixSquadron="\uf511";
export const faPhone="\uf095";
export const faPhoneAlt="\uf879";
export const faPhoneLaptop="\uf87a";
export const faPhoneOffice="\uf67d";
export const faPhonePlus="\uf4d2";
export const faPhoneRotary="\uf8d3";
export const faPhoneSlash="\uf3dd";
export const faPhoneSquare="\uf098";
export const faPhoneSquareAlt="\uf87b";
export const faPhoneVolume="\uf2a0";
export const faPhotoVideo="\uf87c";
export const faPhp="\uf457";
export const faPi="\uf67e";
export const faPiano="\uf8d4";
export const faPianoKeyboard="\uf8d5";
export const faPie="\uf705";
export const faPiedPiper="\uf2ae";
export const faPiedPiperAlt="\uf1a8";
export const faPiedPiperHat="\uf4e5";
export const faPiedPiperPp="\uf1a7";
export const faPiedPiperSquare="\ue01e";
export const faPig="\uf706";
export const faPiggyBank="\uf4d3";
export const faPills="\uf484";
export const faPinterest="\uf0d2";
export const faPinterestP="\uf231";
export const faPinterestSquare="\uf0d3";
export const faPizza="\uf817";
export const faPizzaSlice="\uf818";
export const faPlaceOfWorship="\uf67f";
export const faPlane="\uf072";
export const faPlaneAlt="\uf3de";
export const faPlaneArrival="\uf5af";
export const faPlaneDeparture="\uf5b0";
export const faPlaneSlash="\ue069";
export const faPlanetMoon="\ue01f";
export const faPlanetRinged="\ue020";
export const faPlay="\uf04b";
export const faPlayCircle="\uf144";
export const faPlaystation="\uf3df";
export const faPlug="\uf1e6";
export const faPlus="\uf067";
export const faPlusCircle="\uf055";
export const faPlusHexagon="\uf300";
export const faPlusOctagon="\uf301";
export const faPlusSquare="\uf0fe";
export const faPodcast="\uf2ce";
export const faPodium="\uf680";
export const faPodiumStar="\uf758";
export const faPoliceBox="\ue021";
export const faPoll="\uf681";
export const faPollH="\uf682";
export const faPollPeople="\uf759";
export const faPoo="\uf2fe";
export const faPooStorm="\uf75a";
export const faPoop="\uf619";
export const faPopcorn="\uf819";
export const faPortalEnter="\ue022";
export const faPortalExit="\ue023";
export const faPortrait="\uf3e0";
export const faPoundSign="\uf154";
export const faPowerOff="\uf011";
export const faPray="\uf683";
export const faPrayingHands="\uf684";
export const faPrescription="\uf5b1";
export const faPrescriptionBottle="\uf485";
export const faPrescriptionBottleAlt="\uf486";
export const faPresentation="\uf685";
export const faPrint="\uf02f";
export const faPrintSearch="\uf81a";
export const faPrintSlash="\uf686";
export const faProcedures="\uf487";
export const faProductHunt="\uf288";
export const faProjectDiagram="\uf542";
export const faProjector="\uf8d6";
export const faPumpMedical="\ue06a";
export const faPumpSoap="\ue06b";
export const faPumpkin="\uf707";
export const faPushed="\uf3e1";
export const faPuzzlePiece="\uf12e";
export const faPython="\uf3e2";
export const faQq="\uf1d6";
export const faQrcode="\uf029";
export const faQuestion="\uf128";
export const faQuestionCircle="\uf059";
export const faQuestionSquare="\uf2fd";
export const faQuidditch="\uf458";
export const faQuinscape="\uf459";
export const faQuora="\uf2c4";
export const faQuoteLeft="\uf10d";
export const faQuoteRight="\uf10e";
export const faQuran="\uf687";
export const faRProject="\uf4f7";
export const faRabbit="\uf708";
export const faRabbitFast="\uf709";
export const faRacquet="\uf45a";
export const faRadar="\ue024";
export const faRadiation="\uf7b9";
export const faRadiationAlt="\uf7ba";
export const faRadio="\uf8d7";
export const faRadioAlt="\uf8d8";
export const faRainbow="\uf75b";
export const faRaindrops="\uf75c";
export const faRam="\uf70a";
export const faRampLoading="\uf4d4";
export const faRandom="\uf074";
export const faRaspberryPi="\uf7bb";
export const faRavelry="\uf2d9";
export const faRaygun="\ue025";
export const faReact="\uf41b";
export const faReacteurope="\uf75d";
export const faReadme="\uf4d5";
export const faRebel="\uf1d0";
export const faReceipt="\uf543";
export const faRecordVinyl="\uf8d9";
export const faRectangleLandscape="\uf2fa";
export const faRectanglePortrait="\uf2fb";
export const faRectangleWide="\uf2fc";
export const faRecycle="\uf1b8";
export const faRedRiver="\uf3e3";
export const faReddit="\uf1a1";
export const faRedditAlien="\uf281";
export const faRedditSquare="\uf1a2";
export const faRedhat="\uf7bc";
export const faRedo="\uf01e";
export const faRedoAlt="\uf2f9";
export const faRefrigerator="\ue026";
export const faRegistered="\uf25d";
export const faRemoveFormat="\uf87d";
export const faRenren="\uf18b";
export const faRepeat="\uf363";
export const faRepeat1="\uf365";
export const faRepeat1Alt="\uf366";
export const faRepeatAlt="\uf364";
export const faReply="\uf3e5";
export const faReplyAll="\uf122";
export const faReplyd="\uf3e6";
export const faRepublican="\uf75e";
export const faResearchgate="\uf4f8";
export const faResolving="\uf3e7";
export const faRestroom="\uf7bd";
export const faRetweet="\uf079";
export const faRetweetAlt="\uf361";
export const faRev="\uf5b2";
export const faRibbon="\uf4d6";
export const faRing="\uf70b";
export const faRingsWedding="\uf81b";
export const faRoad="\uf018";
export const faRobot="\uf544";
export const faRocket="\uf135";
export const faRocketLaunch="\ue027";
export const faRocketchat="\uf3e8";
export const faRockrms="\uf3e9";
export const faRoute="\uf4d7";
export const faRouteHighway="\uf61a";
export const faRouteInterstate="\uf61b";
export const faRouter="\uf8da";
export const faRss="\uf09e";
export const faRssSquare="\uf143";
export const faRubleSign="\uf158";
export const faRuler="\uf545";
export const faRulerCombined="\uf546";
export const faRulerHorizontal="\uf547";
export const faRulerTriangle="\uf61c";
export const faRulerVertical="\uf548";
export const faRunning="\uf70c";
export const faRupeeSign="\uf156";
export const faRust="\ue07a";
export const faRv="\uf7be";
export const faSack="\uf81c";
export const faSackDollar="\uf81d";
export const faSadCry="\uf5b3";
export const faSadTear="\uf5b4";
export const faSafari="\uf267";
export const faSalad="\uf81e";
export const faSalesforce="\uf83b";
export const faSandwich="\uf81f";
export const faSass="\uf41e";
export const faSatellite="\uf7bf";
export const faSatelliteDish="\uf7c0";
export const faSausage="\uf820";
export const faSave="\uf0c7";
export const faSaxHot="\uf8db";
export const faSaxophone="\uf8dc";
export const faScalpel="\uf61d";
export const faScalpelPath="\uf61e";
export const faScanner="\uf488";
export const faScannerImage="\uf8f3";
export const faScannerKeyboard="\uf489";
export const faScannerTouchscreen="\uf48a";
export const faScarecrow="\uf70d";
export const faScarf="\uf7c1";
export const faSchlix="\uf3ea";
export const faSchool="\uf549";
export const faScrewdriver="\uf54a";
export const faScribd="\uf28a";
export const faScroll="\uf70e";
export const faScrollOld="\uf70f";
export const faScrubber="\uf2f8";
export const faScythe="\uf710";
export const faSdCard="\uf7c2";
export const faSearch="\uf002";
export const faSearchDollar="\uf688";
export const faSearchLocation="\uf689";
export const faSearchMinus="\uf010";
export const faSearchPlus="\uf00e";
export const faSearchengin="\uf3eb";
export const faSeedling="\uf4d8";
export const faSellcast="\uf2da";
export const faSellsy="\uf213";
export const faSendBack="\uf87e";
export const faSendBackward="\uf87f";
export const faSensor="\ue028";
export const faSensorAlert="\ue029";
export const faSensorFire="\ue02a";
export const faSensorOn="\ue02b";
export const faSensorSmoke="\ue02c";
export const faServer="\uf233";
export const faServicestack="\uf3ec";
export const faShapes="\uf61f";
export const faShare="\uf064";
export const faShareAll="\uf367";
export const faShareAlt="\uf1e0";
export const faShareAltSquare="\uf1e1";
export const faShareSquare="\uf14d";
export const faSheep="\uf711";
export const faShekelSign="\uf20b";
export const faShield="\uf132";
export const faShieldAlt="\uf3ed";
export const faShieldCheck="\uf2f7";
export const faShieldCross="\uf712";
export const faShieldVirus="\ue06c";
export const faShip="\uf21a";
export const faShippingFast="\uf48b";
export const faShippingTimed="\uf48c";
export const faShirtsinbulk="\uf214";
export const faShishKebab="\uf821";
export const faShoePrints="\uf54b";
export const faShopify="\ue057";
export const faShoppingBag="\uf290";
export const faShoppingBasket="\uf291";
export const faShoppingCart="\uf07a";
export const faShopware="\uf5b5";
export const faShovel="\uf713";
export const faShovelSnow="\uf7c3";
export const faShower="\uf2cc";
export const faShredder="\uf68a";
export const faShuttleVan="\uf5b6";
export const faShuttlecock="\uf45b";
export const faSickle="\uf822";
export const faSigma="\uf68b";
export const faSign="\uf4d9";
export const faSignIn="\uf090";
export const faSignInAlt="\uf2f6";
export const faSignLanguage="\uf2a7";
export const faSignOut="\uf08b";
export const faSignOutAlt="\uf2f5";
export const faSignal="\uf012";
export const faSignal1="\uf68c";
export const faSignal2="\uf68d";
export const faSignal3="\uf68e";
export const faSignal4="\uf68f";
export const faSignalAlt="\uf690";
export const faSignalAlt1="\uf691";
export const faSignalAlt2="\uf692";
export const faSignalAlt3="\uf693";
export const faSignalAltSlash="\uf694";
export const faSignalSlash="\uf695";
export const faSignalStream="\uf8dd";
export const faSignature="\uf5b7";
export const faSimCard="\uf7c4";
export const faSimplybuilt="\uf215";
export const faSink="\ue06d";
export const faSiren="\ue02d";
export const faSirenOn="\ue02e";
export const faSistrix="\uf3ee";
export const faSitemap="\uf0e8";
export const faSith="\uf512";
export const faSkating="\uf7c5";
export const faSkeleton="\uf620";
export const faSketch="\uf7c6";
export const faSkiJump="\uf7c7";
export const faSkiLift="\uf7c8";
export const faSkiing="\uf7c9";
export const faSkiingNordic="\uf7ca";
export const faSkull="\uf54c";
export const faSkullCow="\uf8de";
export const faSkullCrossbones="\uf714";
export const faSkyatlas="\uf216";
export const faSkype="\uf17e";
export const faSlack="\uf198";
export const faSlackHash="\uf3ef";
export const faSlash="\uf715";
export const faSledding="\uf7cb";
export const faSleigh="\uf7cc";
export const faSlidersH="\uf1de";
export const faSlidersHSquare="\uf3f0";
export const faSlidersV="\uf3f1";
export const faSlidersVSquare="\uf3f2";
export const faSlideshare="\uf1e7";
export const faSmile="\uf118";
export const faSmileBeam="\uf5b8";
export const faSmilePlus="\uf5b9";
export const faSmileWink="\uf4da";
export const faSmog="\uf75f";
export const faSmoke="\uf760";
export const faSmoking="\uf48d";
export const faSmokingBan="\uf54d";
export const faSms="\uf7cd";
export const faSnake="\uf716";
export const faSnapchat="\uf2ab";
export const faSnapchatGhost="\uf2ac";
export const faSnapchatSquare="\uf2ad";
export const faSnooze="\uf880";
export const faSnowBlowing="\uf761";
export const faSnowboarding="\uf7ce";
export const faSnowflake="\uf2dc";
export const faSnowflakes="\uf7cf";
export const faSnowman="\uf7d0";
export const faSnowmobile="\uf7d1";
export const faSnowplow="\uf7d2";
export const faSoap="\ue06e";
export const faSocks="\uf696";
export const faSolarPanel="\uf5ba";
export const faSolarSystem="\ue02f";
export const faSort="\uf0dc";
export const faSortAlphaDown="\uf15d";
export const faSortAlphaDownAlt="\uf881";
export const faSortAlphaUp="\uf15e";
export const faSortAlphaUpAlt="\uf882";
export const faSortAlt="\uf883";
export const faSortAmountDown="\uf160";
export const faSortAmountDownAlt="\uf884";
export const faSortAmountUp="\uf161";
export const faSortAmountUpAlt="\uf885";
export const faSortCircle="\ue030";
export const faSortCircleDown="\ue031";
export const faSortCircleUp="\ue032";
export const faSortDown="\uf0dd";
export const faSortNumericDown="\uf162";
export const faSortNumericDownAlt="\uf886";
export const faSortNumericUp="\uf163";
export const faSortNumericUpAlt="\uf887";
export const faSortShapesDown="\uf888";
export const faSortShapesDownAlt="\uf889";
export const faSortShapesUp="\uf88a";
export const faSortShapesUpAlt="\uf88b";
export const faSortSizeDown="\uf88c";
export const faSortSizeDownAlt="\uf88d";
export const faSortSizeUp="\uf88e";
export const faSortSizeUpAlt="\uf88f";
export const faSortUp="\uf0de";
export const faSoundcloud="\uf1be";
export const faSoup="\uf823";
export const faSourcetree="\uf7d3";
export const faSpa="\uf5bb";
export const faSpaceShuttle="\uf197";
export const faSpaceStationMoon="\ue033";
export const faSpaceStationMoonAlt="\ue034";
export const faSpade="\uf2f4";
export const faSparkles="\uf890";
export const faSpeakap="\uf3f3";
export const faSpeaker="\uf8df";
export const faSpeakerDeck="\uf83c";
export const faSpeakers="\uf8e0";
export const faSpellCheck="\uf891";
export const faSpider="\uf717";
export const faSpiderBlackWidow="\uf718";
export const faSpiderWeb="\uf719";
export const faSpinner="\uf110";
export const faSpinnerThird="\uf3f4";
export const faSplotch="\uf5bc";
export const faSpotify="\uf1bc";
export const faSprayCan="\uf5bd";
export const faSprinkler="\ue035";
export const faSquare="\uf0c8";
export const faSquareFull="\uf45c";
export const faSquareRoot="\uf697";
export const faSquareRootAlt="\uf698";
export const faSquarespace="\uf5be";
export const faSquirrel="\uf71a";
export const faStackExchange="\uf18d";
export const faStackOverflow="\uf16c";
export const faStackpath="\uf842";
export const faStaff="\uf71b";
export const faStamp="\uf5bf";
export const faStar="\uf005";
export const faStarAndCrescent="\uf699";
export const faStarChristmas="\uf7d4";
export const faStarExclamation="\uf2f3";
export const faStarHalf="\uf089";
export const faStarHalfAlt="\uf5c0";
export const faStarOfDavid="\uf69a";
export const faStarOfLife="\uf621";
export const faStarShooting="\ue036";
export const faStarfighter="\ue037";
export const faStarfighterAlt="\ue038";
export const faStars="\uf762";
export const faStarship="\ue039";
export const faStarshipFreighter="\ue03a";
export const faStaylinked="\uf3f5";
export const faSteak="\uf824";
export const faSteam="\uf1b6";
export const faSteamSquare="\uf1b7";
export const faSteamSymbol="\uf3f6";
export const faSteeringWheel="\uf622";
export const faStepBackward="\uf048";
export const faStepForward="\uf051";
export const faStethoscope="\uf0f1";
export const faStickerMule="\uf3f7";
export const faStickyNote="\uf249";
export const faStocking="\uf7d5";
export const faStomach="\uf623";
export const faStop="\uf04d";
export const faStopCircle="\uf28d";
export const faStopwatch="\uf2f2";
export const faStopwatch20="\ue06f";
export const faStore="\uf54e";
export const faStoreAlt="\uf54f";
export const faStoreAltSlash="\ue070";
export const faStoreSlash="\ue071";
export const faStrava="\uf428";
export const faStream="\uf550";
export const faStreetView="\uf21d";
export const faStretcher="\uf825";
export const faStrikethrough="\uf0cc";
export const faStripe="\uf429";
export const faStripeS="\uf42a";
export const faStroopwafel="\uf551";
export const faStudiovinari="\uf3f8";
export const faStumbleupon="\uf1a4";
export const faStumbleuponCircle="\uf1a3";
export const faSubscript="\uf12c";
export const faSubway="\uf239";
export const faSuitcase="\uf0f2";
export const faSuitcaseRolling="\uf5c1";
export const faSun="\uf185";
export const faSunCloud="\uf763";
export const faSunDust="\uf764";
export const faSunHaze="\uf765";
export const faSunglasses="\uf892";
export const faSunrise="\uf766";
export const faSunset="\uf767";
export const faSuperpowers="\uf2dd";
export const faSuperscript="\uf12b";
export const faSupple="\uf3f9";
export const faSurprise="\uf5c2";
export const faSuse="\uf7d6";
export const faSwatchbook="\uf5c3";
export const faSwift="\uf8e1";
export const faSwimmer="\uf5c4";
export const faSwimmingPool="\uf5c5";
export const faSword="\uf71c";
export const faSwordLaser="\ue03b";
export const faSwordLaserAlt="\ue03c";
export const faSwords="\uf71d";
export const faSwordsLaser="\ue03d";
export const faSymfony="\uf83d";
export const faSynagogue="\uf69b";
export const faSync="\uf021";
export const faSyncAlt="\uf2f1";
export const faSyringe="\uf48e";
export const faTable="\uf0ce";
export const faTableTennis="\uf45d";
export const faTablet="\uf10a";
export const faTabletAlt="\uf3fa";
export const faTabletAndroid="\uf3fb";
export const faTabletAndroidAlt="\uf3fc";
export const faTabletRugged="\uf48f";
export const faTablets="\uf490";
export const faTachometer="\uf0e4";
export const faTachometerAlt="\uf3fd";
export const faTachometerAltAverage="\uf624";
export const faTachometerAltFast="\uf625";
export const faTachometerAltFastest="\uf626";
export const faTachometerAltSlow="\uf627";
export const faTachometerAltSlowest="\uf628";
export const faTachometerAverage="\uf629";
export const faTachometerFast="\uf62a";
export const faTachometerFastest="\uf62b";
export const faTachometerSlow="\uf62c";
export const faTachometerSlowest="\uf62d";
export const faTaco="\uf826";
export const faTag="\uf02b";
export const faTags="\uf02c";
export const faTally="\uf69c";
export const faTanakh="\uf827";
export const faTape="\uf4db";
export const faTasks="\uf0ae";
export const faTasksAlt="\uf828";
export const faTaxi="\uf1ba";
export const faTeamspeak="\uf4f9";
export const faTeeth="\uf62e";
export const faTeethOpen="\uf62f";
export const faTelegram="\uf2c6";
export const faTelegramPlane="\uf3fe";
export const faTelescope="\ue03e";
export const faTemperatureDown="\ue03f";
export const faTemperatureFrigid="\uf768";
export const faTemperatureHigh="\uf769";
export const faTemperatureHot="\uf76a";
export const faTemperatureLow="\uf76b";
export const faTemperatureUp="\ue040";
export const faTencentWeibo="\uf1d5";
export const faTenge="\uf7d7";
export const faTennisBall="\uf45e";
export const faTerminal="\uf120";
export const faText="\uf893";
export const faTextHeight="\uf034";
export const faTextSize="\uf894";
export const faTextWidth="\uf035";
export const faTh="\uf00a";
export const faThLarge="\uf009";
export const faThList="\uf00b";
export const faTheRedYeti="\uf69d";
export const faTheaterMasks="\uf630";
export const faThemeco="\uf5c6";
export const faThemeisle="\uf2b2";
export const faThermometer="\uf491";
export const faThermometerEmpty="\uf2cb";
export const faThermometerFrigid="\uf768";
export const faThermometerFull="\uf2c7";
export const faThermometerHalf="\uf2c9";
export const faThermometerQuarter="\uf2ca";
export const faThermometerThreeQuarters="\uf2c8";
export const faTheta="\uf69e";
export const faThinkPeaks="\uf731";
export const faThumbsDown="\uf165";
export const faThumbsUp="\uf164";
export const faThumbtack="\uf08d";
export const faThunderstorm="\uf76c";
export const faThunderstormMoon="\uf76d";
export const faThunderstormSun="\uf76e";
export const faTicket="\uf145";
export const faTicketAlt="\uf3ff";
export const faTiktok="\ue07b";
export const faTilde="\uf69f";
export const faTimes="\uf00d";
export const faTimesCircle="\uf057";
export const faTimesHexagon="\uf2ee";
export const faTimesOctagon="\uf2f0";
export const faTimesSquare="\uf2d3";
export const faTint="\uf043";
export const faTintSlash="\uf5c7";
export const faTire="\uf631";
export const faTireFlat="\uf632";
export const faTirePressureWarning="\uf633";
export const faTireRugged="\uf634";
export const faTired="\uf5c8";
export const faToggleOff="\uf204";
export const faToggleOn="\uf205";
export const faToilet="\uf7d8";
export const faToiletPaper="\uf71e";
export const faToiletPaperAlt="\uf71f";
export const faToiletPaperSlash="\ue072";
export const faTombstone="\uf720";
export const faTombstoneAlt="\uf721";
export const faToolbox="\uf552";
export const faTools="\uf7d9";
export const faTooth="\uf5c9";
export const faToothbrush="\uf635";
export const faTorah="\uf6a0";
export const faToriiGate="\uf6a1";
export const faTornado="\uf76f";
export const faTractor="\uf722";
export const faTradeFederation="\uf513";
export const faTrademark="\uf25c";
export const faTrafficCone="\uf636";
export const faTrafficLight="\uf637";
export const faTrafficLightGo="\uf638";
export const faTrafficLightSlow="\uf639";
export const faTrafficLightStop="\uf63a";
export const faTrailer="\ue041";
export const faTrain="\uf238";
export const faTram="\uf7da";
export const faTransgender="\uf224";
export const faTransgenderAlt="\uf225";
export const faTransporter="\ue042";
export const faTransporter1="\ue043";
export const faTransporter2="\ue044";
export const faTransporter3="\ue045";
export const faTransporterEmpty="\ue046";
export const faTrash="\uf1f8";
export const faTrashAlt="\uf2ed";
export const faTrashRestore="\uf829";
export const faTrashRestoreAlt="\uf82a";
export const faTrashUndo="\uf895";
export const faTrashUndoAlt="\uf896";
export const faTreasureChest="\uf723";
export const faTree="\uf1bb";
export const faTreeAlt="\uf400";
export const faTreeChristmas="\uf7db";
export const faTreeDecorated="\uf7dc";
export const faTreeLarge="\uf7dd";
export const faTreePalm="\uf82b";
export const faTrees="\uf724";
export const faTrello="\uf181";
export const faTriangle="\uf2ec";
export const faTriangleMusic="\uf8e2";
export const faTripadvisor="\uf262";
export const faTrophy="\uf091";
export const faTrophyAlt="\uf2eb";
export const faTruck="\uf0d1";
export const faTruckContainer="\uf4dc";
export const faTruckCouch="\uf4dd";
export const faTruckLoading="\uf4de";
export const faTruckMonster="\uf63b";
export const faTruckMoving="\uf4df";
export const faTruckPickup="\uf63c";
export const faTruckPlow="\uf7de";
export const faTruckRamp="\uf4e0";
export const faTrumpet="\uf8e3";
export const faTshirt="\uf553";
export const faTty="\uf1e4";
export const faTumblr="\uf173";
export const faTumblrSquare="\uf174";
export const faTurkey="\uf725";
export const faTurntable="\uf8e4";
export const faTurtle="\uf726";
export const faTv="\uf26c";
export const faTvAlt="\uf8e5";
export const faTvMusic="\uf8e6";
export const faTvRetro="\uf401";
export const faTwitch="\uf1e8";
export const faTwitter="\uf099";
export const faTwitterSquare="\uf081";
export const faTypewriter="\uf8e7";
export const faTypo3="\uf42b";
export const faUber="\uf402";
export const faUbuntu="\uf7df";
export const faUfo="\ue047";
export const faUfoBeam="\ue048";
export const faUikit="\uf403";
export const faUmbraco="\uf8e8";
export const faUmbrella="\uf0e9";
export const faUmbrellaBeach="\uf5ca";
export const faUncharted="\ue084";
export const faUnderline="\uf0cd";
export const faUndo="\uf0e2";
export const faUndoAlt="\uf2ea";
export const faUnicorn="\uf727";
export const faUnion="\uf6a2";
export const faUniregistry="\uf404";
export const faUnity="\ue049";
export const faUniversalAccess="\uf29a";
export const faUniversity="\uf19c";
export const faUnlink="\uf127";
export const faUnlock="\uf09c";
export const faUnlockAlt="\uf13e";
export const faUnsplash="\ue07c";
export const faUntappd="\uf405";
export const faUpload="\uf093";
export const faUps="\uf7e0";
export const faUsb="\uf287";
export const faUsbDrive="\uf8e9";
export const faUsdCircle="\uf2e8";
export const faUsdSquare="\uf2e9";
export const faUser="\uf007";
export const faUserAlien="\ue04a";
export const faUserAlt="\uf406";
export const faUserAltSlash="\uf4fa";
export const faUserAstronaut="\uf4fb";
export const faUserChart="\uf6a3";
export const faUserCheck="\uf4fc";
export const faUserCircle="\uf2bd";
export const faUserClock="\uf4fd";
export const faUserCog="\uf4fe";
export const faUserCowboy="\uf8ea";
export const faUserCrown="\uf6a4";
export const faUserEdit="\uf4ff";
export const faUserFriends="\uf500";
export const faUserGraduate="\uf501";
export const faUserHardHat="\uf82c";
export const faUserHeadset="\uf82d";
export const faUserInjured="\uf728";
export const faUserLock="\uf502";
export const faUserMd="\uf0f0";
export const faUserMdChat="\uf82e";
export const faUserMinus="\uf503";
export const faUserMusic="\uf8eb";
export const faUserNinja="\uf504";
export const faUserNurse="\uf82f";
export const faUserPlus="\uf234";
export const faUserRobot="\ue04b";
export const faUserSecret="\uf21b";
export const faUserShield="\uf505";
export const faUserSlash="\uf506";
export const faUserTag="\uf507";
export const faUserTie="\uf508";
export const faUserTimes="\uf235";
export const faUserUnlock="\ue058";
export const faUserVisor="\ue04c";
export const faUsers="\uf0c0";
export const faUsersClass="\uf63d";
export const faUsersCog="\uf509";
export const faUsersCrown="\uf6a5";
export const faUsersMedical="\uf830";
export const faUsersSlash="\ue073";
export const faUsps="\uf7e1";
export const faUssunnah="\uf407";
export const faUtensilFork="\uf2e3";
export const faUtensilKnife="\uf2e4";
export const faUtensilSpoon="\uf2e5";
export const faUtensils="\uf2e7";
export const faUtensilsAlt="\uf2e6";
export const faVaadin="\uf408";
export const faVacuum="\ue04d";
export const faVacuumRobot="\ue04e";
export const faValueAbsolute="\uf6a6";
export const faVectorSquare="\uf5cb";
export const faVenus="\uf221";
export const faVenusDouble="\uf226";
export const faVenusMars="\uf228";
export const faVest="\ue085";
export const faVestPatches="\ue086";
export const faVhs="\uf8ec";
export const faViacoin="\uf237";
export const faViadeo="\uf2a9";
export const faViadeoSquare="\uf2aa";
export const faVial="\uf492";
export const faVials="\uf493";
export const faViber="\uf409";
export const faVideo="\uf03d";
export const faVideoPlus="\uf4e1";
export const faVideoSlash="\uf4e2";
export const faVihara="\uf6a7";
export const faVimeo="\uf40a";
export const faVimeoSquare="\uf194";
export const faVimeoV="\uf27d";
export const faVine="\uf1ca";
export const faViolin="\uf8ed";
export const faVirus="\ue074";
export const faVirusSlash="\ue075";
export const faViruses="\ue076";
export const faVk="\uf189";
export const faVnv="\uf40b";
export const faVoicemail="\uf897";
export const faVolcano="\uf770";
export const faVolleyballBall="\uf45f";
export const faVolume="\uf6a8";
export const faVolumeDown="\uf027";
export const faVolumeMute="\uf6a9";
export const faVolumeOff="\uf026";
export const faVolumeSlash="\uf2e2";
export const faVolumeUp="\uf028";
export const faVoteNay="\uf771";
export const faVoteYea="\uf772";
export const faVrCardboard="\uf729";
export const faVuejs="\uf41f";
export const faWagonCovered="\uf8ee";
export const faWalker="\uf831";
export const faWalkieTalkie="\uf8ef";
export const faWalking="\uf554";
export const faWallet="\uf555";
export const faWand="\uf72a";
export const faWandMagic="\uf72b";
export const faWarehouse="\uf494";
export const faWarehouseAlt="\uf495";
export const faWasher="\uf898";
export const faWatch="\uf2e1";
export const faWatchCalculator="\uf8f0";
export const faWatchFitness="\uf63e";
export const faWatchmanMonitoring="\ue087";
export const faWater="\uf773";
export const faWaterLower="\uf774";
export const faWaterRise="\uf775";
export const faWaveSine="\uf899";
export const faWaveSquare="\uf83e";
export const faWaveTriangle="\uf89a";
export const faWaveform="\uf8f1";
export const faWaveformPath="\uf8f2";
export const faWaze="\uf83f";
export const faWebcam="\uf832";
export const faWebcamSlash="\uf833";
export const faWeebly="\uf5cc";
export const faWeibo="\uf18a";
export const faWeight="\uf496";
export const faWeightHanging="\uf5cd";
export const faWeixin="\uf1d7";
export const faWhale="\uf72c";
export const faWhatsapp="\uf232";
export const faWhatsappSquare="\uf40c";
export const faWheat="\uf72d";
export const faWheelchair="\uf193";
export const faWhistle="\uf460";
export const faWhmcs="\uf40d";
export const faWifi="\uf1eb";
export const faWifi1="\uf6aa";
export const faWifi2="\uf6ab";
export const faWifiSlash="\uf6ac";
export const faWikipediaW="\uf266";
export const faWind="\uf72e";
export const faWindTurbine="\uf89b";
export const faWindWarning="\uf776";
export const faWindow="\uf40e";
export const faWindowAlt="\uf40f";
export const faWindowClose="\uf410";
export const faWindowFrame="\ue04f";
export const faWindowFrameOpen="\ue050";
export const faWindowMaximize="\uf2d0";
export const faWindowMinimize="\uf2d1";
export const faWindowRestore="\uf2d2";
export const faWindows="\uf17a";
export const faWindsock="\uf777";
export const faWineBottle="\uf72f";
export const faWineGlass="\uf4e3";
export const faWineGlassAlt="\uf5ce";
export const faWix="\uf5cf";
export const faWizardsOfTheCoast="\uf730";
export const faWodu="\ue088";
export const faWolfPackBattalion="\uf514";
export const faWonSign="\uf159";
export const faWordpress="\uf19a";
export const faWordpressSimple="\uf411";
export const faWpbeginner="\uf297";
export const faWpexplorer="\uf2de";
export const faWpforms="\uf298";
export const faWpressr="\uf3e4";
export const faWreath="\uf7e2";
export const faWrench="\uf0ad";
export const faXRay="\uf497";
export const faXbox="\uf412";
export const faXing="\uf168";
export const faXingSquare="\uf169";
export const faYCombinator="\uf23b";
export const faYahoo="\uf19e";
export const faYammer="\uf840";
export const faYandex="\uf413";
export const faYandexInternational="\uf414";
export const faYarn="\uf7e3";
export const faYelp="\uf1e9";
export const faYenSign="\uf157";
export const faYinYang="\uf6ad";
export const faYoast="\uf2b1";
export const faYoutube="\uf167";
export const faYoutubeSquare="\uf431";
export const faZhihu="\uf63f";